import type { NavigateFunction } from 'react-router-dom';
import i18next from '../../i18n/initI18n';
import type { MailingChannel } from './mailingTypes';
import { createCampaign, createCampaignFromChannelChain } from './mailingStorage';
import { fetchVisualMailings, upsertVisualMailing } from './visualMailingsApi';
import { apiPost } from '../../api/client';

function uniqueVisualMailingName(baseName: string, existing: { name?: string }[]): string {
  const base = baseName.trim() || i18next.t('common.newChain');
  const names = new Set(existing.map((m) => String(m.name || '').trim().toLowerCase()));
  if (!names.has(base.toLowerCase())) return base;
  let i = 2;
  while (names.has(`${base} ${i}`.toLowerCase())) i += 1;
  return `${base} ${i}`;
}

export async function openNewVisualMailing(navigate: NavigateFunction, name = i18next.t('common.newChain')) {
  const existing = await fetchVisualMailings();
  const c = createCampaign(uniqueVisualMailingName(name, existing));
  await upsertVisualMailing(c);
  navigate({ pathname: `/mailing/${c.id}`, search: '?draft=1' }, { replace: true });
}

export async function openVisualTemplateMailing(navigate: NavigateFunction, name: string, channels: MailingChannel[]) {
  const c = createCampaignFromChannelChain(name.trim() || i18next.t('common.templatePrefix'), channels);
  await upsertVisualMailing(c);
  navigate(`/mailing/${c.id}`, { replace: true });
}

/** Создаёт новую визуальную цепочку и сразу привязывает её к кампании, после чего открывает редактор. */
export async function openAndLinkNewVisualMailingForCampaign(
  navigate: NavigateFunction,
  campaignId: string,
  name = i18next.t('common.newChain'),
) {
  const existing = await fetchVisualMailings();
  const c = createCampaign(uniqueVisualMailingName(name, existing));
  await upsertVisualMailing(c);
  await apiPost<{ ok: boolean }>(`/api/campaigns/${campaignId}/link-visual-chain`, {
    visualMailingId: c.id,
  });
  navigate(`/mailing/${c.id}`, { replace: true });
  return c;
}
